import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import swal from 'sweetalert';

import {getCookie} from '../../../inc/cookies';
import config from '../../../inc/config';
import {isoToDateTime} from '../../../inc/helper';

class HelpModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,

      articles: [],

      pageCount: 0,
      resultCount: 0,
      currentPage: 1,
      limit: 10
    };
  }

  componentDidMount() {
    this.getHelps(this.state.currentPage);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
  }

  getHelps(currentPage) {
    let sessionHash = getCookie('sessionHash');
  
    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };
  
    const startIndex = 0;
    const endIndex = startIndex + this.state.limit;
  
    fetch(config.restApi + `helpArticles/tr?limit=${this.state.limit}&page=${currentPage}`, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          const currentArticles = responseData.articles.slice(startIndex, endIndex);
          this.setState({isLoading: false, articles: currentArticles, pageCount: responseData.pageCount, resultCount: responseData.resultCount, currentPage: currentPage});
        }
        break;
        default: {
          this.setState({isLoading: false});
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(() => this.props.navigate('/home'));
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  handlePageClick(page) {
    this.setState({currentPage: page.selected + 1}, () => this.getHelps(this.state.currentPage))
  }

  render() {
    return this.state.isLoading ?
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
      :
      <>
        <div className="row">
          <div className="col">
            <div className="ibox">
              <div className="ibox-title text-darkblue d-flex justify-content-between pr-1">
                <div className="col-7 col-xl-8"><h5>Yardım Listesi</h5></div>
                <Link className="btn btn-orange" titile="Blog Ekle" to="/helpAdd"><i className="fa fa-plus"></i> Yardım Ekle</Link>
              </div>
              <div className="table-responsive overflow-x-auto">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr className="text-center text-darkblue">
                      <th>Başlık</th>
                      <th>Yazar</th>
                      <th>Görüntülenme</th>
                      <th>Eklenme Tarihi</th>
                      <th>Durum</th>
                      <th>İşlem</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {this.state.articles.map((article) =>
                      <tr key={article.id}>
                        <td className="align-middle">{article.title}</td>
                        <td className="align-middle">{article.author}</td>
                        <td className="align-middle"><i className="fa fa-eye mr-1 pointer" title="Görüntüleme"></i>{article.views}</td>
                        <td className="align-middle">{isoToDateTime(article.added_date)}</td>
                        <td className="align-middle">{article.active === 1 ? 'Açık' : 'Kapalı'}</td>
                        <td className="align-middle">
                          <Link className="btn btn-orange text-center"to={"/helpEdit?id=" + article.id}><i className="fa fa-pencil text-white action-icon"></i></Link>
                        </td>
                      </tr>
                    )}
                    {this.state.articles.length === 0 && 
                      <tr>
                        <td className="align-middle p-3" colSpan="6">Yardım Bulunamadı !</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              {
                this.state.articles.length !== 0 &&
                <ReactPaginate
                previousLabel={"Geri"}
                nextLabel={"İleri"}
                breakLabel={"..."}  
                pageCount={this.state.pageCount}
                marginPagesDisplayed={1}
                onPageChange={page => this.handlePageClick(page)}
                pageRangeDisplayed={2}
                containerClassName={'pagination'}
                activeClassName={'activePage'}
                />
              }
            </div>
          </div>
        </div>
      </>
  }
}

export default function Helps() {
  return (
    <HelpModule navigate={useNavigate()} />
  )
}